import { useMutation } from '@tanstack/react-query';
import { getQualifications as getQualificationsService } from 'services/api/AgentCenterAPI';

export const useGetQualifications = () => {
    const {
        mutateAsync: getQualifications,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: getQualificationsService,
    });

    return { getQualifications, isPending, ...rest };
};
